var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container-fluid" },
    [
      this.step === 1
        ? _c("system-custom-notifications-create-notification")
        : _vm._e(),
      _vm._v(" "),
      this.step === 2
        ? _c("system-custom-notifications-select-users")
        : _vm._e(),
      _vm._v(" "),
      this.step === 3
        ? _c("system-custom-notifications-send-notification")
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }